import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { MdManageSearch } from "react-icons/md";
import "./Header.css";
import { searchQuestions } from "../../features/search/searchSlice";
import { useDispatch, useSelector } from "react-redux";

function Header() {
  const [toggleSearchMenu, setToggleSearchMenu] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [searchSuggestions, setSearchSuggestions] = useState([]);
  const [searchInputFocused, setSearchInputFocused] = useState(false);
  const [focusedSuggestion, setFocusedSuggestion] = useState(null);
  const dispatch = useDispatch();
  const navigator = useNavigate();

  const searchResponse = useSelector((state) => state.searchQuery.data);

  const searchRef = useRef();
  useEffect(() => {
    const debouncedHandler = setTimeout(() => {
      if (searchInput.trim() !== "") {
        dispatch(searchQuestions({ searchQuery: searchInput, type: "basic" }));
      } else {
        setSearchSuggestions([]);
      }
    }, 500);

    return () => clearTimeout(debouncedHandler);
  }, [dispatch, searchInput]);



  const handleSearchFocus = () => {
    setSearchInputFocused(!searchInputFocused);
    searchRef.current.focus();
  };

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (
        (e.key === "ArrowUp" || e.key === "ArrowDown") &&
        searchInputFocused
      ) {
        e.preventDefault();
        const currentIndex = searchSuggestions.findIndex(
          (suggestion) => suggestion === focusedSuggestion
        );
        let nextIndex;
        if (e.key === "ArrowUp") {
          nextIndex =
            currentIndex === -1 || currentIndex === 0
              ? searchSuggestions.length - 1
              : currentIndex - 1;
        } else {
          nextIndex =
            currentIndex === -1 || currentIndex === searchSuggestions.length - 1
              ? 0
              : currentIndex + 1;
        }
        setFocusedSuggestion(searchSuggestions[nextIndex]);
      } else if (e.key === "/") {
        searchRef.current.focus();
        handleSearchFocus();
      } else if (e.key === "Escape") {
        handleSearchFocus();
        e.preventDefault();
      } else if (e.key === "Enter" && focusedSuggestion) {
        handleSuggestionClick(focusedSuggestion);
      }else if(e.key === "Enter" && searchInputFocused){
        handleSearchButtonClick();
      }
    };

    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
    // eslint-disable-next-line
  }, [searchSuggestions, focusedSuggestion]);


  useEffect(() => {
    const handleDocumentClick = (e) => {
      if (!searchRef.current.contains(e.target) && !e.target.classList.contains("search-btn") && !e.target.classList.contains("searchSuggestions")) {
        setSearchInputFocused(false);
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const handleSearchButtonClick = () => {
    dispatch(searchQuestions({ searchQuery: searchInput, type: "deep" }));
  };

  const handleSearchInputChange = (e) => {
    const inputValue = e.target.value;
    setSearchInput(inputValue);
  };

  useEffect(() => {
    if (searchResponse) {
      setSearchSuggestions(searchResponse);
    }
  }, [searchResponse]);

  const handleSuggestionClick = (suggestion) => {
    // setSearchInput(suggestion.questionText);
    navigator(
      `/categories/${suggestion.courseName}/${suggestion.difficultyLevel}/${suggestion._id}`
    );
    setSearchInputFocused(false);
    setSearchSuggestions([]);
  };


  return (
    <header className="bg-gray-950 header flex items-center justify-around px-4 py-2">
      <div
        className="logo flex items-center"
        onClick={() => (window.location.href = "/")}
      >
        <p className="logoText text-white text-2xl font-bold">
          <span className="logoFirstChar">s</span>tudent
          <span className="logoSubText">webgeniuscraft</span>
        </p>
      </div>

      <MdManageSearch
        className={`toogleSearchMenu bg-gray-800 ${
          toggleSearchMenu ? "text-gray-950" : "hidden"
        }`}
        onClick={() => setToggleSearchMenu(!toggleSearchMenu)}
      />

      <nav className={`flex justify-center ${toggleSearchMenu && "active"}`}>
        <ul className="flex space-x-4">
          <li>
            <Link to="/" className="text-darkblue-color hover:underline">
              Home
            </Link>
          </li>
          <li className="dropdown relative">
            <span className="cursor-pointer text-darkblue-color">
              Interview Questions
            </span>
            <div className="dropdownContent z-10 absolute top-full left-0 hidden bg-gray-800 shadow-md py-2 w-full">
              <Link
                to="/categories/javascript"
                className="block px-4 py-2 text-gray-100 hover:bg-gray-950"
              >
                JavaScript
              </Link>
              <Link
                to="/categories/python"
                className="block px-4 py-2 text-gray-100 hover:bg-gray-950"
              >
                Python
              </Link>
              <Link
                to="/categories/java"
                className="block px-4 py-2 text-gray-100 hover:bg-gray-950 disabled"
              >
              <strike>Java</strike>
              </Link>
            </div>
          </li>
          {/* <li>
            <Link to="/about" className="text-darkblue-color hover:underline">
              About
            </Link>
          </li>
          <li>
            <Link to="/contact" className="text-darkblue-color hover:underline">
              Contact
            </Link>
          </li> */}
        </ul>
      </nav>

      <div
        className={`searchBox flex items-center  ${searchInputFocused && "focusedSearchBox"} ${
          toggleSearchMenu ? "active" : ""
        }`}
      >
        <input
          type="text"
          placeholder="Search..."
          className="bg-slate-50 text-gray-950 border border-secondary-color py-2 px-4 rounded-l-md focus:outline-none"
          value={searchInput}
          onChange={handleSearchInputChange}
          ref={searchRef}
          onClick={() => setSearchInputFocused(true)}
        />
        <button
          className="search-btn text-lavender-color px-4 bg-gray-950 py-2 rounded-r-md"
          disabled={searchInput.trim() === "" ? true : false}
          onClick={handleSearchButtonClick}
        >
          Search
        </button>

        {searchResponse && searchSuggestions.length > 0 && searchInputFocused && (
          <div className={`searchSuggestions bg-gray-950/60`}>
            {searchSuggestions.map((suggestion) => (
              <div
                key={suggestion._id}
                className={`suggestionItem ${
                  suggestion === focusedSuggestion ? "focused" : ""
                }`}
                onClick={() => handleSuggestionClick(suggestion)}
              >
                {suggestion.questionText}
              </div>
            ))}
          </div>
        )}

        {!searchResponse && searchInput && searchInputFocused && (
          <div className={`searchSuggestions bg-gray-800/40`}>
            <div className="suggestionItem">No Results</div>
          </div>
        )}
      </div>
    </header>
  );
}

export default Header;
